import React from 'react'
import STAFF_3 from '../Work-Assets/WhatsApp Image 2025-01-11 at 10.01.18.jpeg';

function Rev_News({rev_web, rev_news}) {
    const sub = () =>{

        rev_web(true)
        rev_news(false)

    }
  return (
    <div className='revs_web'>
        
        <div className='news'>
        <p className='fill_In'>Student News</p>
            <div className='news_Cont'>
                <div className='news_image'><img src={STAFF_3} /></div>
                <p className='marketing_Words'>
               Welcome to Hostel Adventures – Where Comfort Meets Adventure
               Nestled in the heart of a vibrant community, our hostel offers more than just a place to stay – it’s the perfect blend of 
   comfort and adventure. Imagine waking up to clear blue skies, surrounded by a modern and welcoming space designed to inspire exploration. 
   Whether you’re here for a short stay or an extended journey, we provide a unique experience that goes beyond the ordinary</p>

            </div>

        </div>
        <div className='rev_BTNS'>
        <div className='submit' onClick={sub}>Student Reviews</div>
        </div>
    </div>
  )
}

export default Rev_News